<script setup lang="ts">
import { useSelectedLogSorterStore } from '../stores/selectedLogSorterStore';
import { storeToRefs } from 'pinia';
import { InputText, InputNumber, Fieldset, ToggleButton, Fluid, ToggleSwitch } from 'primevue';
import { useTranslations } from 'shared/translations/composables/useTranslations.ts';



const store = useSelectedLogSorterStore();
const translations = useTranslations();

const {
  bins,
  operation,
} = storeToRefs(store);

bins.value.forEach(bin => {
  console.log(bin);
});

</script>

<template>

  <div class="bin-panel">

    <div v-bind:key="bin.name" v-for="bin in bins" class="field ">

      <Fieldset :legend="bin.name">
        <div class="bin">
          <div class="field col-span-2" :class="{ changed: operation === 'edit' && bin.hasChanged.identifier }">
            <label>{{ translations.logSorter.panel.identifier }}</label>
            <InputText fluid v-model:model-value="bin.identifier" @update:model-value="store.onBinChanged(true)"></InputText>
          </div>
          <div class="field" :class="{ changed: operation === 'edit' && bin.hasChanged.width }">
            <label>{{ translations.generic.width }}</label>
            <InputNumber fluid v-model:model-value="bin.width" show-buttons button-layout="horizontal" :step="0.1"
              @update:model-value="store.onBinChanged(true)">
              <template #incrementicon>
                <span class="pi pi-plus" />
              </template>
              <template #decrementicon>
                <span class="pi pi-minus" />
              </template>
            </InputNumber>
          </div>
          <div class="field" :class="{ changed: operation === 'edit' && bin.hasChanged.length }">
            <label>{{  translations.generic.length }}</label>
            <InputNumber fluid v-model:model-value="bin.length" show-buttons button-layout="horizontal" :step="0.1"
              @update:model-value="store.onBinChanged(true)">
              <template #incrementicon>
                <span class="pi pi-plus" />
              </template>
              <template #decrementicon>
                <span class="pi pi-minus" />
              </template>
            </InputNumber>
          </div>
          <div class="field" :class="{ changed: operation === 'edit' && bin.hasChanged.offsetY }">
            <label>{{ translations.logSorter.panel.offsetY }}</label>
            <InputNumber fluid v-model:model-value="bin.offsetY" show-buttons button-layout="horizontal" :step="0.1"
              @update:model-value="store.onBinChanged(true)">
              <template #incrementicon>
                <span class="pi pi-plus" />
              </template>
              <template #decrementicon>
                <span class="pi pi-minus" />
              </template>
            </InputNumber>
          </div>
          <div class="field" :class="{ changed: operation === 'edit' && bin.hasChanged.offsetX }">
            <label>{{ translations.logSorter.panel.offsetX }}</label>
            <InputNumber fluid v-model:model-value="bin.offsetX" show-buttons button-layout="horizontal" :step="0.1"
              @update:model-value="store.onBinChanged(true)">
              <template #incrementicon>
                <span class="pi pi-plus" />
              </template>
              <template #decrementicon>
                <span class="pi pi-minus" />
              </template>
            </InputNumber>
          </div>
        </div>
      </Fieldset>
    </div>
  </div>

</template>

<style scoped>
.bin-panel {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: .5rem;
  column-gap: .5rem;
}

.bin {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: .5rem;
  column-gap: .5rem;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
